<template>
    <button class="gray-button " 
        :class="{ 
            blue,
            gray: !blue,
            ...oToHide,
            ...oSetBald,
            ...aClassName,
        }"
        :disabled="disabled"
    >
        <slot></slot>
    </button>
</template>

<script setup>
const oProps = defineProps({
    hide: {
        type: Array, // top, bottom, left, right,
    },
    bald: {
        type: [Boolean, Array],
    },
    blue: {// 蓝色模式
        type: Boolean,
    },
    disabled: {
        type: Boolean,
    },
    fullWidth: {
        type: Boolean,
        default: true,
    },
});

const oToHide = computed(()=>{
    const oResult = {};
    (oProps.hide || []).forEach(oCur => {
        oResult[`hide-${oCur}`] = true;
    });
    return oResult;
});

const oSetBald = computed(()=>{
    const oResult = {};
    // console.log("oProps.bald", oProps.bald);
    if (oProps.bald === true){
        oResult.bald = true;
    }else if(oProps.bald.length){
        oProps.bald.forEach(oCur => {
            oResult[`bald-${oCur}`] = true;
        });
    }
    return oResult;
});

const aClassName = computed(()=>{
    const aResult = {};
    if (oProps.fullWidth) aResult['full-with'] = true;
    return aResult;
});

</script>

<style lang="scss" scoped>
.gray-button{
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.24px;
    line-height: 1;
    padding: 7px 12px;
    text-align: center;
    transition: background-color .1s ease-in-out, border-color .1s ease-in-out,color .1s ease-in-out;
    white-space: nowrap;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    &.gray{
        background-color: #37465c4d;
        border: 1px solid var(--color_grey-60);
        color: var(--color_grey-20);
        &:not([disabled]):hover{
            background-color: #37465c80;
        }
    }
    &.blue{
        background: linear-gradient(1turn, #0c5eff 0.8%, #1398f9);
        box-shadow: 0 3px 28px rgba(34, 131, 246, 0.4), inset 0 3px 3px rgba(255, 255, 255, 0.3019607843);
        color: var(--color_white);
        &:hover{
            filter: contrast(1.3);
        }
    }
    :deep(svg:not([fill])){
        fill: currentColor;
    }
}

.gray-button{
    &[class~=full-with]{
        width: 100%;
    }
    // ▼去除圆角
    &[class~=hide-top]{
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        &[class~=bald]{
            border-top: none;
        }
    }
    &[class~=hide-bottom]{
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        &[class~=bald]{
            border-bottom: none;
        }
    }
    &[class~=hide-left]{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        &[class~=bald]{
            border-left: none;
        }
    }
    &[class~=hide-right]{
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        &[class~=bald]{
            border-right: none;
        }
    }
    // ▼去除描边
    &[class~=bald-top]{
        border-top: none;
    }
    &[class~=bald-bottom]{
        border-bottom: none;
    }
    &[class~=bald-left]{
        border-left: none;
    }
    &[class~=bald-right]{
        border-right: none;
    }
}

</style>


